import {
  Box, Form, Line, SectionDivider, Text,
} from '@domain-group/suit-theme'

import type { ActivityModel } from '@domain-group/realhub-backend-api-types'

interface RecipientDetailsProps {
  parameters: ActivityModel['parameters'],
}

const RecipientDetails = (props: RecipientDetailsProps) => {
  const { parameters } = props

  const {
    body, from, recipients, title, type,
  } = parameters || {}

  return (
    <>
      <SectionDivider boxProps={{ marginBottom: 'large' }}>{type} Details</SectionDivider>

      <Box fontSize="small" flexDirection="column" marginBottom="small">
        <Form.Field label="Sender">
          <Text>{from}</Text>
        </Form.Field>

        <Line style={{ borderStyle: 'dashed' }} />

        <Form.Field label="Recipients">
          <Text lineHeight={1.5}>{recipients?.join(', ')}</Text>
        </Form.Field>

        <Line style={{ borderStyle: 'dashed' }} />

        <Form.Field label="Message">
          <Text>{body || title}</Text>
        </Form.Field>

        <Line style={{ borderStyle: 'dashed' }} />
      </Box>
    </>

  )
}

export default RecipientDetails
